"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SubscribeBenefits = require("./SubscribeBenefits");
Object.keys(_SubscribeBenefits).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SubscribeBenefits[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SubscribeBenefits[key];
    }
  });
});
